import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { memberMove, memberRepairMoney } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      tagList: [{
        key: 0,
        value: '补款'
      }, {
        key: 1,
        value: '扣款'
      }],
      accountList: [{
        key: 'money1',
        value: '消费账户'
      }, {
        key: 'money2',
        value: '奖金账户'
      } // {key:'money3',value:'充值中心'},
      // {key:'money4',value:'复销账户'},
      // {key:'money5',value:'云仓账户'},
      ],
      form: {
        number: '',
        type: 'money1',
        tag: 0,
        happen_money: '',
        remark: ''
      },
      rules: {
        happen_money: [{
          require: true,
          validator: this.$tempModel.rules.money.validator,
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show(number, finish) {
      this.dialogVisible = true;
      this.form.number = number;
      this.finish = finish;
    },
    clickSubmit: function clickSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this.$g.fun.startLoading();

          memberRepairMoney(_this.form).then(function _callee(res) {
            return regeneratorRuntime.async(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _this.$g.fun.endLoading();

                    _this.$message({
                      message: '操作成功',
                      type: 'success'
                    });

                    _this.dialogVisible = false;

                    if (_this.finish) {
                      _this.finish();
                    }

                  case 4:
                  case "end":
                    return _context.stop();
                }
              }
            });
          });
        }
      });
    }
  }
};